export default {
  setting: 'Setting',
  account: 'Account Settings',
  password: 'Account Password',
};
